export function groupFromDto(dto) {
    if (dto.type !== 'AD') {
        return dto;
    }

    const groupName = dto.groupName.replace(/^OU:/, '');
    const cname = dto.groupName.replace(/(^OU:|\(Everyone\)$)/g, '');
    const parentName = ((dto.adDistinguishedName || '').split('OU=')[1] || '').split(',')[0];

    const isEveryone = dto.groupName.endsWith('(Everyone)');
    const isOu = dto.groupName.startsWith('OU:');
    const type = !isEveryone ? 'AD_GROUP' : isOu ? 'AD_OU' : 'AD_DOMAIN';

    return {...dto, groupName, cname, parentName, type};
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/group.dto.js